import './musicalAnimatedBackground.css';

/**
 * Aurora background for the auth surface.
 *
 * Layers (back to front):
 *   1. Deep base with seated warm pools
 *   2. Four blurred aurora blobs drifting on independent loops
 *   3. SVG fractal-noise grain (vector film grain)
 *   4. Radial vignette to focus the foreground card
 *
 * All motion is GPU-composited CSS — no per-frame JS. Honors
 * prefers-reduced-motion by pausing the aurora drift.
 */
const MusicalAnimatedBackground = ({ children }) => {
    return (
        <div className="musical-animated-background">
            <div className="mab-base" aria-hidden="true" />
            <div className="mab-aurora mab-aurora--1" aria-hidden="true" />
            <div className="mab-aurora mab-aurora--2" aria-hidden="true" />
            <div className="mab-aurora mab-aurora--3" aria-hidden="true" />
            <div className="mab-aurora mab-aurora--4" aria-hidden="true" />
            <svg
                className="mab-grain"
                aria-hidden="true"
                focusable="false"
                xmlns="http://www.w3.org/2000/svg"
            >
                <filter id="mab-noise">
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.9"
                        numOctaves="2"
                        stitchTiles="stitch"
                    />
                    {/* Convert RGB noise to grayscale so overlay blends as true grain */}
                    <feColorMatrix
                        type="matrix"
                        values="0.33 0.34 0.33 0 0
                                0.33 0.34 0.33 0 0
                                0.33 0.34 0.33 0 0
                                0    0    0    0 1"
                    />
                </filter>
                <rect width="100%" height="100%" filter="url(#mab-noise)" />
            </svg>
            <div className="mab-vignette" aria-hidden="true" />
            <div className="content-overlay">
                {children}
            </div>
        </div>
    );
};

export default MusicalAnimatedBackground;
